<template>
    <div :style="style">
        <Wp_jd_hot_sku_model
                :hot-datas="hotShowList"
                :auto-play="auto_play"
                :icon="icon"
                :title="title"
                :title-style="title_style"
                :img-gray="imgGray"
                @clickItem="clickItem"
        ></Wp_jd_hot_sku_model>

        <div v-if="showCard" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 99999; "

                :style="{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.7)'}"
        >
            <div :style="{width: $common.screenWidth + 'px', height: ($common.screenHeight / 2 - 150) + 'px'}"
                 @click="clickCloseIcon">
            </div>
            <div style="">

                <div v-if="skuInfoData && showCard" style="background-color: white; padding: 3px 0px">
                    <!--                <div style="text-align: right; font-size: 13px; color: #EE0A24; margin-right: 10px; padding-top: 10px"-->
                    <!--                     @click="showSkuDetail(skuInfoData)">-->
                    <!--                    查看详情-->
                    <!--                </div>-->
                    <Divider dashed
                             style="background-color: #EE0A24;padding-left: 10px;padding-right: 10px; margin-top: 10px; margin-bottom: 10px"></Divider>
                    <JdSkuInfoCard
                            :skuInfo="skuInfoData"
                            @addInSelectList="addInSelectList"
                    ></JdSkuInfoCard>
                </div>
                <div style="text-align: center" @click="clickCloseIcon">
                    <van-icon name="close" size="40" color="#FFFFFF"
                              style="padding-top: 50px"
                    />
                </div>
            </div>
            <div :style="{width: $common.screenWidth + 'px', height: ($common.screenHeight / 2 - 150) + 'px'}"
                 @click="clickCloseIcon">
            </div>
        </div>

        <van-popup
                v-model="showDetail"
                position="bottom"
                :style="{ width: '100%', height: '100%'}"
        >
            <Wp_jd_sku_detail_page v-if="skuInfoData && showDetail"
                    type="popup"
                    :datas="skuInfoData"
                    @clickToCloseDetail="clickToCloseDetail"
            ></Wp_jd_sku_detail_page>
        </van-popup>
    </div>
</template>

<script>
    import Wp_jd_hot_sku_model from "../custom/Wp_jd_hot_sku_model";
    import Wp_jd_sku_detail_page from "../pages_childs/Wp_jd_sku_detail_page";
    import JdSkuInfoCard from "../custom/JdSkuInfoCard";
    export default {
        name: "Wp_home_hot_model",
        components: {JdSkuInfoCard, Wp_jd_sku_detail_page, Wp_jd_hot_sku_model},

        inject: ['JdSelectListSheet_parent'],

        props:{
            params:{type: Object},
            imgGray:{type: Boolean, default: false}
        },

        data(){
            return{
                auto_play: 5000,
                url: "",
                hotDatas: [],
                hotShowList: [],
                icon:"",
                title: "",
                title_style: "",
                style: "",

                showDetail: false,

                skuInfoData: null,

                showCard: false,
            }
        },

        created() {
            this.initHotDatas();
        },

        methods:{
            initHotDatas(){
                if(this.params){
                    if(this.params.auto_play){
                        this.auto_play = this.params.auto_play;
                    }
                    if(this.params.icon){
                        this.icon = this.params.icon;
                    }
                    if(this.params.title){
                        this.title = this.params.title;
                    }
                    if(this.params.title_style){
                        this.title_style = this.params.title_style;
                    }
                    if(this.params.url){
                        this.url = this.params.url;

                        this.getHotDatas(null, datas=> {
                            this.hotDatas = datas;
                            this.hotShowList = this.group(this.hotDatas, 3);
                        })
                    }
                    if(this.params.style){
                        this.style = this.params.style;
                    }
                }
            },

            clickToCloseDetail(){
                this.showDetail = false;
            },

            getHotDatas(params, fn){
                this.$getDatasWithUrlAndParams(this.url, params, response=>{
                    if(response && response.code === 200){
                        if(fn){
                            fn(response.data);
                        }
                    }
                })
            },

            group(array, subGroupLength) {
                let mo = array.length % subGroupLength;//取模
                let new_length = array.length - mo;//减去余出的数值，以保证获得的new_length可以被subGroupLength整除
                let index = 0;
                let newArray = [];
                while(index < new_length) {
                    newArray.push(array.slice(index, index += subGroupLength));
                }
                return newArray;
            },

            clickCloseIcon(){
                this.showCard = false;
            },
            clickToCloseCard(){
                this.showCard = false;
                this.showSkuDetail(this.skuInfoData);
            },

            clickItem(item){
                this.$log("this.$config.project = " + this.$config.project)
                this.$log("this.$common.getPid() = " + this.$common.getPid())
                if(!this.$common.isClient_whole() && this.$common.getPid()){
                    let _skuInfo = item;
                    //添加一个时间戳，已保证如果是同一个商品，在详情页面也能通过watch监听到
                    _skuInfo.time_tag = new Date().getTime();

                    this.skuInfoData = _skuInfo;

                    this.showCard = true;

                }else{
                    this.showSkuDetail(item);
                }
            },

            showSkuDetail(item){
                //h5页面打开详情
                if(!this.$common.gloabl_wx_mini_user_info || !this.$common.gloabl_wx_mini_user_info.u_code){
                    // this.$common.static_skuInfo = item;
                    // this.$common.static_scroll_top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                    // this.$router.push('sku_detail');

                    let _skuInfo = item;
                    //添加一个时间戳，已保证如果是同一个商品，在详情页面也能通过watch监听到
                    _skuInfo.time_tag = new Date().getTime();

                    this.skuInfoData = _skuInfo;

                    this.showDetail = true;
                }else{
                    let _skuId = item.skuId;

                    if (_skuId) {
                        //小程序中，使用小程序的page打开详情
                        this.navigateToDetail(JSON.stringify(_skuId));
                    }
                }
            },

            /**
             * 添加商品到选品清单中
             */
            addInSelectList(skuInfo, skuId) {
                this.$emit("hotItemAddToSelected", skuInfo, skuId);
            },

            /**
             * 打开小程序中的详情界面
             */
            navigateToDetail(sku_str) {
                this.$common.navigateToMiniProgramPage("../wp_detail/wp_detail?", "skuId", sku_str)
            },
        }
    }
</script>

<style scoped>

</style>